(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["peptrolix-cart-upsell"] && !Shopify.designMode) return;
  try {
    class PeptrolixCartUpsell extends HTMLElement {
    connectedCallback() {
      this.statusEl = this.querySelector('[data-pcu-status]');
      this.cartUrl = this.dataset.cartUrl || '/cart/add';
      this.errorLabel = this.dataset.errorLabel || 'That could not be added.';

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-pcu-add]');
        if (button) this.add(button);
      });
    }

    async add(button) {
      const id = Number(button.dataset.variant);
      if (!id) return;

      button.disabled = true;
      if (this.statusEl) this.statusEl.textContent = '';

      try {
        const response = await fetch(this.cartUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] })
        });

        if (!response.ok) throw new Error('cart-error');

        await this.refreshSection();
      } catch (error) {
        if (this.statusEl) this.statusEl.textContent = this.errorLabel;
        button.disabled = false;
      }
    }

    // Re-render just the cart section in place via the Section Rendering API,
    // keeping scroll position. The section id is read from the wrapper Shopify
    // renders around every section, so nothing is hardcoded. Any failure falls
    // back to a full reload, which is what this did unconditionally before.
    async refreshSection() {
      const wrapper = this.closest('[id^="shopify-section-"]');
      const sectionId = wrapper ? wrapper.id.replace('shopify-section-', '') : null;

      if (!sectionId) {
        window.location.reload();
        return;
      }

      try {
        const url = `${window.location.pathname}?sections=${encodeURIComponent(sectionId)}`;
        const response = await fetch(url);
        if (!response.ok) throw new Error('section-error');

        const sections = await response.json();
        const html = sections[sectionId];
        if (!html) throw new Error('section-missing');

        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const fresh = parsed.querySelector(`#${wrapper.id}`) || parsed.body;
        wrapper.innerHTML = fresh.innerHTML;
      } catch (error) {
        window.location.reload();
      }
    }
  }

  if (!customElements.get('peptrolix-cart-upsell')) {
    customElements.define('peptrolix-cart-upsell', PeptrolixCartUpsell);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["peptrolix-sticky-buy"] && !Shopify.designMode) return;
  try {
    class PeptrolixStickyBuy extends HTMLElement {
    connectedCallback() {
      // The buy box renders either the tier selector (.pxp-tiers) or the plain
      // quantity row (.pxp-form__row), never both. Watch whichever exists —
      // anchoring to only one leaves no trigger in the other mode, and the
      // fallback below would then pin the bar open from page load.
      this.trigger = document.querySelector('.pxp-tiers, .pxp-form__row');
      this.priceEl = this.querySelector('[data-psb-price]');
      this.variantInput = this.querySelector('[data-psb-variant]');
      this.quantityInput = this.querySelector('[data-psb-quantity]');
      this.submit = this.querySelector('[data-psb-submit]');
      this.restock = this.querySelector('[data-psb-restock]');
      this.sourceSelect = document.querySelector('.pxp-field select[name="id"]');

      this.variants = {};
      const payload = this.querySelector('[data-psb-variants]');
      if (payload) {
        try {
          this.variants = JSON.parse(payload.textContent);
        } catch (error) {
          this.variants = {};
        }
      }

      this.classList.add('psb--ready');
      document.body.classList.add('psb-active');
      this.observe();
      this.syncFromSource();
      this.syncTier();
    }

    // Mirror the tier the customer picked in the main buy box. Without this the
    // bar always submits the minimum quantity: someone who chose "3 units,
    // save 15%" would be silently sold one unit at full price.
    syncTier() {
      const tiers = document.querySelector('.pxp-tiers');
      if (!tiers || !this.quantityInput) return;

      const mirror = () => {
        const checked = tiers.querySelector('.pxp-tier__input:checked');
        if (!checked) return;
        this.quantityInput.value = checked.value;
        // Show the tier's line total, not the single-unit price, so the bar
        // displays the same figure as the buy box for the same action.
        const total = checked.getAttribute('data-pxp-tier-total');
        if (total && this.priceEl) this.priceEl.textContent = total;
      };

      mirror();
      tiers.addEventListener('change', mirror);
    }

    observe() {
      if (!this.trigger || typeof IntersectionObserver === 'undefined') {
        this.classList.add('psb--visible');
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.classList.toggle('psb--visible', !entry.isIntersecting);
          });
        },
        { rootMargin: '0px 0px -40px 0px' }
      );

      this.observer.observe(this.trigger);
    }

    syncFromSource() {
      if (!this.sourceSelect) return;
      this.sourceSelect.addEventListener('change', () => this.update(this.sourceSelect.value));
    }

    update(variantId) {
      const variant = this.variants[variantId];
      if (!variant) return;

      if (this.variantInput) this.variantInput.value = variantId;
      if (this.priceEl) this.priceEl.textContent = variant.price;
      if (this.submit) this.submit.hidden = !variant.available;
      if (this.restock) this.restock.hidden = variant.available;
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      document.body.classList.remove('psb-active');
    }
  }

  if (!customElements.get('peptrolix-sticky-buy')) {
    customElements.define('peptrolix-sticky-buy', PeptrolixStickyBuy);
  }
  } catch(e) { console.error(e); }
})();

})();
